import { render, staticRenderFns } from "./articulo.vue?vue&type=template&id=2eecdc5b&"
import script from "./articulo.vue?vue&type=script&lang=js&"
export * from "./articulo.vue?vue&type=script&lang=js&"
import style0 from "./articulo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports